import { useCallback, useEffect, useMemo, useState } from "react";
import { getIconCandidates } from "../../utils/mcp-favicon";

export function useFallbackIcon(icon: string | string[] | null | undefined) {
  const iconCandidates = useMemo(() => getIconCandidates(icon), [icon]);
  const [iconIndex, setIconIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(iconCandidates.length > 0);

  useEffect(() => {
    setIconIndex(0);
    setIsVisible(iconCandidates.length > 0);
  }, [iconCandidates]);

  const activeIcon = isVisible ? iconCandidates[iconIndex] ?? null : null;

  const handleError = useCallback(() => {
    if (iconIndex < iconCandidates.length - 1) {
      setIconIndex((currentIndex) => currentIndex + 1);
      return;
    }

    setIsVisible(false);
  }, [iconCandidates.length, iconIndex]);

  return {
    activeIcon,
    isVisible,
    handleError,
  };
}
